
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { usePiggybankTranslate } from '@/modules/piggybank/model/translate';
import { ROUTE_NAME_PIGGYBANK } from '@/modules/piggybank/router';

export default defineComponent({
    name: ROUTE_NAME_PIGGYBANK.ITEM.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, beforeFetch, actions, localeSupportedOptions } = usePiggybankTranslate();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { v$, model, fetch, actions, localeSupportedOptions };
    }
});
